<template>
  <div class="h-shr-create">
    <div class="h-shr-create__number">{{ orderNumber }}.</div>
    <button @click="$emit('delete')" class="h-shr-create__delete" type="button">
      <img src="@/assets/img/hm/close.svg" alt="">
    </button>
    <div class="h-shr-create__row">
      <div class="h-shr-create__col">
        <div class="h-shr-create__title">{{ room.room_category.name }}</div>
      </div>
      <div class="h-shr-create__col">
        <div class="h-shr-create__dates">
          <CalendarIcon aria-hidden="true"/>
          <span>{{ fmtDate(room.check_in) }}</span>
          <ArrowIcon />
          <span>{{ fmtDate(room.check_out) }}</span>
        </div>
      </div>
    </div>
    <div class="h-shr-create__row">
      <div class="h-shr-create__col">
        <HMTower horizontal>
          <template #title>Guests:</template>
          <template #body>
            <HMAgeAssignment :accomodation-type="room.accomodation_type" simple />
          </template>
        </HMTower>
      </div>
      <div class="h-shr-create__col">
        <app-cells :indent="false" gap="10px 33px">
          <HMTower horizontal>
            <template #title>Nights:</template>
            <template #body>
              <app-cells :indent="false" gap="10px">
                <HMChip>
                  {{ calcNumberOfNights || '-' }}
                  <template #icon>
                    <NightsIcon aria-hidden="true"/>
                  </template>
                </HMChip>
                <HMChip :color="room.meal_plan.color" isMeal>
                  {{ room.meal_plan.name }}
                </HMChip>
              </app-cells>
            </template>
          </HMTower>
          <HMTower horizontal>
            <template #title>QTY:</template>
            <template #body>
              <input
                v-model.number="modelCount"
                type="number"
                :name="`count_${orderNumber}`"
                class="h-shr-create__input"
                :min="1"
              >
            </template>
          </HMTower>
        </app-cells>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarIcon from '@/views/hotel-management/reservations/detail/icons/CalendarIcon.vue'
import ArrowIcon from '@/views/hotel-management/reservations/detail/icons/ArrowIcon.vue'
import HMAgeAssignment from '@/components/HMAgeAssignment.vue'
import NightsIcon from '@/views/hotel-management/reservations/detail/icons/NightsIcon.vue'
import HMChip from '@/views/hotel-management/reservations/components/HMChip.vue'
import HMTower from '@/components/HMTower.vue'

export default {
  name: 'HotelShortRoomCreate',
  components: { HMTower, HMChip, NightsIcon, HMAgeAssignment, ArrowIcon, CalendarIcon },
  props: {
    room: { type: Object, required: true },
    orderNumber: { type: Number, default: 0 },
  },
  computed: {
    modelCount: {
      get () {
        return this.room && typeof this.room.count !== 'undefined' ? this.room.count : ''
      },
      set (val) {
        const num = Number(val)
        this.$emit('update-count', isNaN(num) ? 0 : num)
      }
    },
    calcNumberOfNights() {
      if (this.room.check_in && this.room.check_out) {
        const date1 = new Date(this.room.check_in)
        const date2 = new Date(this.room.check_out)
        const timeDiff = date2.getTime() - date1.getTime()
        return Math.ceil(timeDiff / (1000 * 3600 * 24)) < 0 ? 0 : Math.ceil(timeDiff / (1000 * 3600 * 24))
      } else {
        return ''
      }
    },
  },
  methods: {
    fmtDate(iso) {
      if (!iso) return ''
      const d = new Date(`${ iso }T00:00:00`)
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return `${ d.getDate() } ${ months[d.getMonth()] }, ${ d.getFullYear() }`
    },
  }
}
</script>

<style scoped>
.h-shr-create {
  position: relative;
  margin-bottom: 10px;
  padding: 19px 30px 16px 58px;
  border-radius: 16px;
  border: 1px solid #e9e9e9;
  background-color: #fff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
}

.h-shr-create:last-child {
  margin-bottom: 0;
}

.h-shr-create__row {
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: center;
  margin-bottom: 10px;
}

.h-shr-create__row:last-child {
  margin-bottom: 0;
}

.h-shr-create__number {
  position: absolute;
  top: 20px;
  left: 24px;
  color: #000;
  font-family: 'MazzardSoftH', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.h-shr-create__delete {
  position: absolute;
  top: 6px;
  right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
}

.h-shr-create__title {
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  font-weight: 500;
}

.h-shr-create__dates {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #000;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 15px;
  line-height: 1;
  font-weight: 500;
}

.h-shr-create__input {
  width: 42px;
  height: 24px;
  border-radius: 6px;
  border: 1px solid #e4e4e4;
  background-color: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  text-align: center;
  padding: 0;
}

.h-shr-create__input::-webkit-inner-spin-button,
.h-shr-create__input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>